export default {
  name: 'NitroBox',
  methods: {
    openNitroUrl () {
      window.open(`${process.env.VUE_APP_KEYBE_CO_URL}producto/keybe-nitro/`, '_blank')
    }
  }
}
